import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
};

const setInfo = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.info = {
      ...state.modulo.retenciones_masivas.tickets.info,
      data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.info.busy = true;
  });

  try {
    const response = await Http.get(`api/timbrado-masivo/retenciones/tickets/${id}`, { params });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.info.busy = false;
      state.modulo.retenciones_masivas.tickets.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.info.busy = false;
      state.modulo.retenciones_masivas.tickets.info.error = error.data || error;
    });
  }
};

const retryStamping = async (store, params) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.info.retry = true;
  });

  const body = {
    tickets: params.tickets,
  };

  try {
    const response = await Http.post(`api/timbrado-masivo/retenciones/tickets/retry`, body);

    window.ToastManager.show({
      variant: 'success',
      title: 'Reintento de timbrado.',
      message: response.message ?? 'Se está reservando los recursos para procesar tu solicitud.',
    });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.info.retry = false;
      state.modulo.retenciones_masivas.tickets.info.result = response;
    });
  } catch (error) {
    window.ToastManager.show({
      variant: 'error',
      title: 'Error',
      message: error.data?.message ?? error.message ?? 'No se pudo procesar tu solicitud.',
    });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.info.busy = false;
      state.modulo.retenciones_masivas.tickets.info.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.info = {
      ...initialState,
    };
  });
};

const RetencionesMasivasTicketsInfoStore = {
  state: () => initialState,
  actions: {
    info,
    setInfo,
    retryStamping,
    reset,
  },
};

export default RetencionesMasivasTicketsInfoStore;
